import { useEffect } from 'react';

import { useNewAccountActions } from './NewAccountContext';

const NewAccountLoader = () => {
  const { initializeState } = useNewAccountActions();

  useEffect(() => {
    initializeState();
  }, []);

  return null;
};

export default NewAccountLoader;
